var sourceFile = require('../../../config/config');

export default {
  run(editor, sendor, opts) {
    window.open(sourceFile.studioUrl, '_self');
  }
};
